export enum GlobalActionTypes {
  SET_SELECTED_PORTFOLIOS = 'SET_SELECTED_PORTFOLIOS',
  REMOVE_SELECTED_PORTFOLIO = 'REMOVE_SELECTED_PORTFOLIO',
  CLEAR_SELECTED_PORTFOLIOS = 'CLEAR_SELECTED_PORTFOLIOS',
  CLEAR_ALL = 'CLEAR_ALL',
  SET_COMPLETE = 'SET_COMPLETE',
  SET_ACCORDION_COMPLETE = 'SET_ACCORDION_COMPLETE',
  CHECK_ALL_ACCORDION_COMPLETE = 'CHECK_ALL_ACCORDION_COMPLETE',
  SHOW_CASHFLOW_REPORT = 'SHOW_CASHFLOW_REPORT',
}

export enum AccordionKeys {
  SELECT_PORTFOLIOS = 'SELECT_PORTFOLIOS',
  OPTIMIZATION_PARAMETER = 'OPTIMIZATION_PARAMETER',
  CANDIDATE_SCREEN = 'CANDIDATE_SCREEN',
  OPTIMIZATION_CONSTRAINTS = 'OPTIMIZATION_CONSTRAINTS',
}

export enum SaveAndLoadModalAction {
  SAVE = 'save',
  LOAD = 'load',
}

export enum ConstraintOperation {
  ADD = 'Apply Goal/Constraint',
  EDIT = 'Update Goal/Constraint',
}

export enum ScaleSpread {
  'Option 1' = 'Optione 1',
  'Option 2' = 'Optione 2',
  'Option 3' = 'Optione 3',
}

export enum OptimizationTypes {
  Index = 'Index',
  Horizon = 'Horizon',
  Dedication = 'Dedication',
  Scenario = 'Scenario',
}

export enum MethodTypes {
  Linear = 'Linear',
  Quadratic = 'Quadratic',
}

export enum ObjectiveTypes {
  Maximize = 'Maximize',
  Minimize = 'Minimize',
}

export enum ObjectiveItems {
  YieldToMaturity = 'Yield to Maturity',
  CashFlowYield = 'Cash Flow Yield',
  DurationToMaturity = 'Duration to Maturity',
  EffectiveDuration1 = 'Effective Duration 1',
  EffectiveDuration2 = 'Effective Duration 2',
  EffectiveDuration3 = 'Effective Duration 3',
  Convexity = 'Convexity',
  EffectiveSpread = 'Effective Spread',
  OutstandingValue = 'Outstanding Value',
  Turnover = 'Turnover',
  AfterTaxYieldToMaturity = 'After-tax Yield to Maturity',
  AfterTaxCashFlowYield = 'After-tax Cash Flow Yield',
  EdurWeightedCashFlowYield = 'Edur-weighted Cash Flow Yield',
  EdurWeightedEffectiveSpread = 'Edur-weighted Effective Spread',
  CustomFunction = 'Custom Function',
  LoadedFunction = 'Loaded Function',
  MarketSensitivity = 'Market Sensitivity',
}

export enum Contributions {
  Contribution = 'Contribution',
  Withdrawal = 'Withdrawal',
}

export enum RiskModel {
  Wilshire = 'Wilshire',
  KeyRates = 'Key Rates',
}

export enum Liabilities {
  SpecifyLiabilityToMatch = 'Specify Liability to Match',
  SpecifyReinvestmentRates = 'Specify Reinvestment Rates',
  SpecifyBorrowingRates = 'Specify Borrowing Rates',
  UsePreAfterTaxFlowsPreTaxCashFlows = 'Use Pre/After Flows Pre-Tax Cash Flows',
}

export enum GridView {
  ScreenCriteria = 'Screen Criteria',
  Securities = 'Securities',
}

export enum CriteriaOperation {
  ADD = 'Add Screen Criteria',
  EDIT = 'Update Screen Criteria',
}
export enum OptimizationConstraintsActionType {
  SET_CONSTRAINTS = 'SET_CONSTRAINTS',
  ADD_CONSTRAINT = 'ADD_CONSTRAINT',
  DELETE_CONSTRAINT = 'DELETE_CONSTRAINT',
  SET_COMPLETE = 'SET_COMPLETE',
  TOGGLE_EXPANDED = 'TOGGLE_EXPANDED',
  RESET = 'RESET',
}

export enum ReportsTab {
  TransactionReport = 0,
  ConstraintReport,
  SummaryReport,
  CashFlowReport,
}

export enum ScreeningItemType {
  PORTFOLIO = 'PORTFOLIO',
  COUP = 'COUP',
  FSTREFD = 'FSTREFD',
  PUTDATE = 'PUTDATE',
  CALLDATE = 'CALLDATE',
  CURWALA = 'CURWALA',
  MEMCODE = 'MEMCODE',
}
